import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgeFilter'
})
export class ImgeFilterPipe implements PipeTransform {

  transform(value: any,isFromPhotosSlide?: boolean): any {
    console.log('value')
    // if(isFromPhotosSlide) {
    //   return value.replace("mobile_photoslide", "photos_module_600x380");
    // }
    return value.replace("desc_tab", "new_inner_index_221x165");
  }
}


// photo_600x380